<template>
    <div>
        <!-- Item Header -->
        <v-flex xs12 style="z-index: 1;">
            <table class="mytable table table-bordered" :class="isInvoiceA5Format ? 'a5format' : 'a4format'" border="1" width="100%" style="border-collapse: collapse;">
                <tr align="left">
                    <th>Serie</th>
                    <th>Data emissão</th>
                    <th>Data vencimento</th>
                    <th>Moeda</th>
                    <th>pag.</th>
                </tr>
                <tr align="left">
                    <td>{{selectedInvoice.sell.series}}</td>
                    <td>{{selectedInvoice.emission_date | formatDate }}</td>
                    <td>{{selectedInvoice.due_date | formatDate }}</td>
                    <td>{{fetchedInvoice.sell.type_currency.name}}</td>
                    <td>pag. {{ currentPage }}/{{ totalPage }}</td>
                </tr>
            </table>
        </v-flex>
        
        <template v-if="!isInvoiceA5Format">
            <br>
        </template>
        
        

        <v-flex xs12 style="z-index: 1;">
            <table class="mytable table table-bordered" :class="isInvoiceA5Format ? 'a5format' : 'a4format'"  border="1" width="100%" style="border-collapse: collapse;">
                <tr>
                    <th align="left" style="width: 12px;">Cod.</th>
                    <th align="left" style="width: 100%;">Descrição</th>
                    <th align="right" style="width: 12px;">Qtd.</th>
                    <th align="right" style="width: 12px;">Preço</th>
                    <th align="right" style="width: 12px;">Desc.</th>
                    <th align="right" style="width: 12px;">Valor</th>
                </tr>
                <tr v-for="(item, index) in sellLines" :key="index">
                    <td>{{item.article.code}}</td>
                    <td class="truncate">{{item.article.name}}</td>
                    <td align="right">{{item.sold_quantity}}</td>
                    <td align="right">{{item.sell_price | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}</td>
                    <td align="right">{{item.discount}}%</td>
                    <td align="right">{{item.subtotal | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' }) }}</td>
                </tr>
            </table>
        </v-flex>
    </div>
</template>

<script>
    export default {
        created () {
            
        },

        data(){
            return {

            }
        },

        watch: {
            
        },

        props:{
            currentPage: {
                type: Number,
                default: 0,
            },
            totalPage: {
                type: Number,
                default: 0,
            },
            fetchedInvoice: {
               type: Object,
               default: () => ({}),
            },
            sellLines: {
                type: Array,
                default: () => [],
            },
            isInvoiceA5Format: {
                type: Boolean,
                default: false,
            },
            isInvoiceCanceled: {
                type: Boolean,
                default: false,
            },
            invoicePrintLabel: {
                type: String,
                default: ""
            },
        },

        computed: {

            selectedInvoice: {
                get(){ return this.$store.getters.getSelectedInvoice; },
                set(value){ this.$store.dispatch('setSelectedInvoice', value); }
            },

        },

        methods: {
            
        }
    }
</script>

<style scoped>

    table.a5format, .a5format tr, .a5format th, .a5format td{
        border-color: LightGray;
        border-left: none;
        border-right: none;
        padding-left: 10px;
        padding-right: 10px;
        font-size: 11px;
    }

    table.a4format, .a4format tr, .a4format th, .a4format td{
        border-color: LightGray;
        border-left: none;
        border-right: none;
        padding-left: 10px;
        padding-right: 10px;
        font-size: 14px;
    }

    table th{
        height: 40px;
    }

    table td{
        height: 30px;
        max-height: 20px;
    }
    
    .truncate {
        max-width: 100px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }


</style>